// /opt/ptg01-v1/front-admin/components/AdminCard.tsx
// Carte de référence (CONVENTIONS.md § 5) avec en-tête optionnel, et ligne libellé / valeur pour les fiches.
import React from 'react';

export function AdminCard({ title, icon, right, children, className = '', bodyClass = '' }: {
    title?: React.ReactNode;
    icon?: React.ReactNode;
    right?: React.ReactNode;
    children: React.ReactNode;
    className?: string;
    bodyClass?: string;
}) {
    return (
        <div className={`bg-white border-2 border-[#000091]/25 rounded-2xl shadow-[0_1px_3px_rgba(0,0,0,0.04)] ${className}`}>
            {title && (
                <div className="px-4 py-3 border-b border-[#000091]/10 flex items-center justify-between gap-2">
                    <div className="text-[11px] font-bold text-[#000091] uppercase tracking-wider flex items-center gap-1.5 shrink-0 whitespace-nowrap">{icon}{title}</div>
                    {right && <div className="min-w-0 truncate text-right text-[10px] text-black/70">{right}</div>}
                </div>
            )}
            <div className={bodyClass}>{children}</div>
        </div>
    );
}

export function DetailRow({ label, value, mono = false }: { label: string; value: React.ReactNode; mono?: boolean }) {
    return (
        <div className="px-4 py-2 flex items-start gap-3 text-[12px]">
            <div className="w-36 shrink-0 text-black/60">{label}</div>
            <div className={`flex-1 min-w-0 text-slate-900 font-medium break-words ${mono ? 'font-mono text-[11px]' : ''}`}>{value ?? <span className="text-black/30">—</span>}</div>
        </div>
    );
}

export function EmptyCard({ icon, title, hint }: { icon?: React.ReactNode; title: string; hint?: string }) {
    return (
        <div className="bg-slate-50 border-2 border-dashed border-slate-200 rounded-2xl p-8 text-center">
            <div className="text-slate-600 mx-auto mb-2 flex justify-center">{icon}</div>
            <p className="text-[13px] text-slate-600">{title}</p>
            {hint && <p className="text-[11px] text-slate-600 mt-1">{hint}</p>}
        </div>
    );
}
